import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { MP_CF_QALBOX_COURSE_FAQ } from '../../../../Constants';

export const useCreateFaq = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createFaqHook = async (faq, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${MP_CF_QALBOX_COURSE_FAQ}`,
        {faq: faq}
      );

      const status = response?.status;
      if (status === 200) {
        setSuccess(true);
        handleUpdate();
      } else {
        setError("Failed to create faq");
      }
    } catch (error) {
      setError("An error occurred while creating faq");
    } finally {
      setLoading(false);
    }
  };

  return [ createFaqHook, loading, error, success ];
};